module.exports = __webpack_public_path__ + "static/media/logo.51f654e8.svg";